<template>
<div class="custom-image">
    <h3 class="m-b-16">Brand image</h3>
    <div :class="$prefixClass.row">
        <a-form-model ref="formCustomImage" :model="formCustomImage" v-bind="layout">
            <div class="m-b-24">
                <label for="Choose image">Choose image</label>
                <vue-upload-image 
                    :maximumSize="maximumSize"
                    :maximumFile="1"
                    :multiple="false"
                    :value="images"
                    :classContainer="$prefixClass.updateImage + '-single'"
                    @change="uploadImages"
                > </vue-upload-image>
            </div>
            <a-form-model-item class="m-b-24" label="Size">
                <a-select :prefixCls="$prefixClass.select" v-model="formCustomImage.size">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listSize" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item class="m-b-24" label="Animation">
                <a-select :prefixCls="$prefixClass.select" v-model="formCustomImage.animation">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listAnimation" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item :label-col="{span: 24}" :wrapper-col="{span: 24}">
               <a-checkbox v-model="formCustomImage.isRepeat">
                   Repeat animation
                </a-checkbox>
            </a-form-model-item>
        </a-form-model>
    </div>
</div>
</template>

<script>
export default {
    name: "CustomImage",
    props: {
        value: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            isMultiple: false,
            maximumSize: 1,
            defaultImgs: ['logo.svg', 'logo-sm.svg'],
            listSize: [
                {
                    text: 'Very small',
                    value: 'very_small'
                },
                {
                    text: 'Small',
                    value: 'small'
                },
                {
                    text: 'Medium',
                    value: 'medium'
                },
                {
                    text: 'Large',
                    value: 'large'
                },
                {
                    text: 'Very large',
                    value: 'very_large'
                }
            ],
            listAnimation: [
                {
                    text: 'None',
                    value: 'none'
                },
                {
                    text: 'Fade in',
                    value: 'fade-in'
                },
                {
                    text: 'Fade out',
                    value: 'fade-out'
                },
            ],
            layout: {
                labelCol: {
                    span: 12
                },
                wrapperCol: {
                    span: 12
                },
            },
        };
    },
    computed: {
        formCustomImage: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            }
        },
        images() {
            let images = []
            if ( this.imgSrc ) {
                images.push({src: this.imgSrc})
            }
            return images
        },
        imgSrc() {
            let src = ""
            if ( this.defaultImgs.includes(this.formCustomImage.imgUrl) ) {
                src = this.getImgUrl(this.formCustomImage.imgUrl)
            } else {
                src = typeof(this.formCustomImage.imgUrl) === 'object' ? this.formCustomImage.imgUrl.src : this.formCustomImage.imgUrl
            }
            return src
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {},
    methods: {
        uploadError() {
        },
        uploadImages(images){
            this.formCustomImage.imgUrl = images.length > 0 ? images[0] : ''
        }
    }
};
</script>

<style lang="scss">
    .choose-image-tooltip {
        .m-tooltip-content {
            width: 250px;
        }
    }
    .custom-image {
        img {
            object-fit: fill !important;
        }
    }
</style>
